/**
 * Visibility control button.
 *
 * Implements IControl:
 * https://docs.mapbox.com/mapbox-gl-js/api/markers/#icontrol
 */
import VisibilityService from "../common/VisibilityService";
import './VisbilityControl.scss';
import { ModalComponentService } from "../common/ModalComponentService";
import type { VisibilityChange, VisibilityChangeHandler } from "../common/VisibilityService";
import type { IControl, Map } from 'mapbox-gl';

class VisbilityControl implements IControl {
    _map: Map | undefined;
    _container = document.createElement('div');
    _button = document.createElement('button');
    _icon = document.createElement('img');

    CLASS_BUTTON_CONTROL = 'mapboxgl-ctrl';
    CLASS_BUTTON_VISIBILITY = 'button_visibility';
    CLASS_ICON = 'button_visibility_icon';
    _boundVisibilityHandler: VisibilityChangeHandler | undefined;

    handleVisibilityChange(payload: VisibilityChange): void {
        if (this._icon && payload?.icon) {
            this._icon.src = payload.icon;
        }
    }

    handleClick(): void {
        console.log('[VisbilityControl] click');
        ModalComponentService.openModalComponent(
            ModalComponentService.ModalComponentTypes.VISIBILITY_SELECTOR_CARD
        );
    }

    onAdd(map: Map): HTMLElement {
        this._map = map;
        this._container.className = this.CLASS_BUTTON_CONTROL + ' mapboxgl-ctrl-group';
        this._button.className = this.CLASS_BUTTON_VISIBILITY;
        this._button.addEventListener('click', this.handleClick.bind(this));

        this._icon.className = this.CLASS_ICON;
        this._icon.src = VisibilityService.getIcon();
        this._icon.alt = 'Visibility';
        this._icon.loading = 'lazy';
        this._icon.decoding = 'async';

        this._button.appendChild(this._icon);
        this._container.appendChild(this._button);

        // Handler to update icon when visibility changes
        this._boundVisibilityHandler = this.handleVisibilityChange.bind(this);
        VisibilityService.addChangeHandler(this._boundVisibilityHandler);

        return this._container;
    }

    onRemove(): void {
        this._container.parentNode!.removeChild(this._container);
        this._map = undefined;
        if (this._boundVisibilityHandler) {
            VisibilityService.removeChangeHandler(this._boundVisibilityHandler);
        }
    }
}

export default VisbilityControl;

